const id_common = {
    accept: "terima",
    action: "aksi",
    active: "aktif",
    active_non: "tidak aktif",
    add: "tambah",
    address: "alamat",
    approve: "setujui",
    attribute: "atribut",
    back: "kembali",

    bank: "bank",
    bank_acc: "rekening bank",

    batch: "batch",
    brand: "merek",
    label: "label",
    barcode: "barcode",

    category: "kategori",
    cancel: "batal",
    choose: "pilih",
    choose_img: "pilih gambar",
    choose_file: "pilih file",

    city: "kota",
    close: "tutup",
    closing: "penutupan stok",
    courier: "kurir",
    code: "kode",
    company: "perusahaan",

    complete: "selesai",
    confirmation: "konfirmasi",
    connected: "terhubung",
    created_by: "dibuat oleh",

    credit: "kredit",
    debit: "debit",
    deposit: 'titipan',

    customer: "pelanggan",
    customer_type: "jenis pelanggan",

    date: "tanggal",
    date_created: "tanggal dibuat",
    date_due: "tanggal jatuh tempo",
    date_delivery: "tanggal pengiriman",
    date_start: "tanggal mulai",
    date_end: "tanggal akhir",
    date_pay: "tanggal pembayaran",
    date_range: "rentang tanggal",
    date_request: "tanggal permintaan",
    date_transaction: "tanggal transaksi",
    date_update: "tanggal diperbarui",

    delete: "hapus",
    delivered: "terkirim",
    detail: "detail",
    description: "keterangan",

    discount: "diskon",

    district: "kelurahan",
    sub_district: "kecamatan",
    province: "provinsi",

    difference: "selisih",
    document_type: "jenis dokumen",
    download_pdf: 'unduh PDF',
    duplicate: "duplikat",
    edit: "ubah",

    email: "email",

    export_excel: "ekspor ke Excel",
    export_csv: "ekspor ke CSV",
    export_pdf: "ekspor ke PDF",

    failed: "gagal",
    finish: "selesai",

    fullname: "nama lengkap",

    goods: "barang",
    goods_list: "daftar barang",
    goods_name_sku: "nama barang / SKU",

    height: "tinggi",
    here: "di sini",
    length: "panjang",
    width: "lebar",
    weight: "berat",

    history: "riwayat",
    image: "gambar",

    in: "masuk",
    out: "keluar",

    info: "informasi",
    language: "bahasa",
    loading: "memuat...",

    location: "lokasi",
    storage: "lokasi penyimpanan",
    method: "metode",

    name: "nama",
    name_full: "nama lengkap",
    npwp: 'NPWP',

    next_month: "bulan depan",
    prev_month: "bulan sebelumnya",

    no_: "tidak",
    no: "nomor",

    no_do: "nomor DO",
    no_delivery: "nomor pengiriman",
    no_invoice: "nomor invoice",
    no_itemin: "nomor barang masuk",
    no_itemout: "nomor barang keluar",
    no_po: "nomor PO",
    no_recap: "nomor rekap",
    no_reference: "nomor referensi",
    no_so: "nomor SO",
    no_transaction: "nomor transaksi",

    note: "catatan",
    no_option: "tidak ada pilihan",
    no_description: "tidak ada keterangan",

    offer: "penawaran",
    paid: "lunas",

    pass: "kata sandi",
    pass_conf: "konfirmasi kata sandi",
    pass_new: "kata sandi baru",
    pass_reset: "atur ulang kata sandi",
    pass_change: "ubah kata sandi",

    payment: "pembayaran",

    percentage: "persentase",
    period: "periode",

    phone: "telepon",
    telp: "telepon",

    price: "harga",
    price_base: "harga dasar",
    price_buy: "harga beli",
    price_sell: "harga jual",
    price_retail: "harga eceran",

    print: "cetak",
    print_whs: "cetak untuk gudang",

    process: "proses",
    progress: "progres",

    profile: "profil",

    quantity: "jumlah",
    quantity_sell: "jumlah terjual",
    qty: "qty",

    recipient: "penerima",
    sender: "pengirim",

    reference: "referensi",
    refresh: "muat ulang",
    reject: "tolak",
    request: "permintaan",

    sales: "penjualan",

    save: "simpan",

    search: "cari",
    select_all: "pilih semua",

    serial_num: "nomor seri",
    sku: "SKU",

    success: "berhasil",

    supplier: "pemasok",
    supplier_type: "jenis pemasok",

    status: "status",
    status_delivery: "status pengiriman",

    stock: "stok",
    stock_init: "stok awal",

    tier: "tingkat",
    to: "ke",

    type: "tipe",
    unit: "satuan",

    upload: "unggah",
    user: "pengguna",

    warehouse: "gudang",
    warehouse_orig: "gudang asal",
    warehouse_dest: "gudang tujuan",

    verification: "verifikasi",
    yes: "ya"
}

export default id_common